<template>
  <div class="organizations-select-field">
    <v-autocomplete
      :value="value"
      :items="items"
      attach
      chips
      deletable-chips
      small-chips
      :label="label"
      :hint="hint"
      persistent-hint
      outlined
      multiple
      item-text="name"
      item-value="id"
      :loading="loading || listLoading"
      :disabled="loading || disabled || listLoading"
      @input="syncValue"
    >
    </v-autocomplete>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapGetters } from 'vuex'
  import rules from '@/mixins/rules'
  import OrganizationDataService from '@/services/api/OrganizationDataService'

  export default {
    name: 'OrganizationsSelectField',
    components: { },
    mixins: [rules],
    data () {
      return {
        listLoading: false,
        items: [],
      }
    },
    props: {
      label: {
        type: String,
        default: 'Организации (Юр-лица)',
      },
      value: {
        type: Array,
        default: () => [],
      },
      emptyText: {
        type: String,
        default: null,
      },
      loading: Boolean,
      disabled: Boolean,
    },
    computed: {
      showEmptyText () {
        return this.emptyText && _.isEmpty(this.value) && !this.loading
      },
      hint () {
        return this.showEmptyText ? this.emptyText : null
      },
      filteredItems () {
        if (!this.search) {
          return this.items
        }
        return this.items.filter((item) => {
          return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        })
      },
    },
    methods: {
      syncValue (value) {
        this.search = ''
        this.$emit('input', value)
      },
    },
    created () {
      this.listLoading = true
      OrganizationDataService.getList()
        .then(res => {
          this.items = res
        })
        .finally(() => {
          this.listLoading = false
        })
    },
  }
</script>

<style lang="less" scoped>
.organizations-select-field {
  ::v-deep {
    .v-text-field {
      .v-label--active {
        transform: translateY(-25px) scale(0.75);
      }

    }

  }

}

.organizations-select-field_search {
  margin-top: -5px;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;

  ::v-deep {
    .v-list-item__content {
      padding-bottom: 0;
    }

    .v-label:not(.v-label--active) {
      top: 0;
    }

  }
}
</style>
